import CustomSetInventoryResultsModalState from "@iewcasia/Store/State/Cart/CustomSetInventoryResultsModalState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import AddToListModalState from "@insite/client-framework/Store/Components/AddToListModal/AddToListModalState";
import { Draft } from "immer";

const initialState: CustomSetInventoryResultsModalState = {
    isOpen: false,
};

const customSetInventoryResultsReducer = {
    "Custom/InventoryResultsModal/CompleteSetIsOpen": (
        draft: Draft<AddToListModalState>,
        action: {
            isOpen: boolean;
            productInfos?: Omit<ProductInfo, "productDetailPath">[];
        },
    ) => {
        if (!action.isOpen) {
            return initialState;
        }

        draft.isOpen = action.isOpen;
        draft.productInfos = action.productInfos;
    },
    "CurrentPage/LoadPageComplete": () => {
        return initialState;
    },
} as any;

export default createTypedReducerWithImmer(initialState, customSetInventoryResultsReducer);
